/**
 * Dms附件上传接口
 * Created by stonewang on 2017/8/29.
 */
import {config, request, objectSerial} from 'Utils';

export const uploadUrl = `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`;
//附件列表
export function getList(param) {
  /**
   *  {
        dealType //上传文件类型（1-渠道；2-渠道联系人；3-门店；4-门店店员）
        id //对应操作Id 渠道ID、门店ID、联系人ID、员工ID
        p,
        s
       }
   */
  return request(`${config.server}/api/v1/dms/commonAttachUpload/getList?${objectSerial(param)}`, {
    method: 'post',
    //body: param,
  });
}
//附件上传
export function upload(param) {
  /**
   *  {
        entityType //上传文件类型（1-渠道；2-渠道联系人；3-门店；4-门店店员）
        entityId //对应操作Id 渠道ID、门店ID、联系人ID、员工ID
       }
   */
  return request(`${config.server}/api/v1/dms/commonAttachUpload/mongoUpload?dealType=${param.entityType}&id=${param.entityId}`, {
    method: 'post',
    body: param,
  });
}
//附件查看
export function getFile(id) { //附件id
  return request(`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${id}`);
}
//附件查看
export function deleteFiles(param) {
  /*
   param: {
   ids: []
   }
  * */
  return request(`${config.server}/api/v1/dms/commonAttachUpload/delete`, {
    method: 'post',
    body: param,
  });
}
//附件下载
export function getFileDown(param) {
  /*
   param: {
   id: 12555//文件id
   }
   * */
  return request(`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${param.id}`);
}
//附件下载次数报告
export function addFileDownCount(param) {
  /*
   param: {
   id: 12555//文件id
   }
   * */
  return request(`${config.server}/api/v1/dms/commonAttachUpload/addFileDownCount?id=${param.id}`);
}



// WEBPACK FOOTER //
// ./src/service/remark/file.js